import React, { useEffect, useState } from 'react';
import Logo from "../../../assest/ahbaab/Logo.png";
import { Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import './HeaderStyle.css';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'
import facebookIcon from '../../../assest/ahbaab/facebook.png';
import InstagramIcon from '../../../assest/ahbaab/instagram.png';
import LinkedInIcon from '../../../assest/ahbaab/linkedin.png';

const Header = () => {
  const location = useLocation();
  const navActive = location.pathname;
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const handleNavClick = () => setMenuOpen(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [menuOpen]);

  return (
    <Box className="pharma_topHeader">
      {/* Left Section */}
      <Link to="/" className="logoContainer" onClick={handleNavClick}>
        <img className="logo" src={Logo} alt="Logo" />
        {/* <span className="pharma_compnyName">Lucency</span> */}
      </Link>

      {/* Hamburger for mobile */}
      <div className="hamburger" onClick={toggleMenu}>
        {menuOpen ? <CloseIcon className=' fs11' /> : <MenuIcon className=' fs11' />}
      </div>

      {/* Nav Links */}
      <ul className={`pharma_liauto ${menuOpen ? 'open' : ''}`}>
        <li><Link to="/" onClick={handleNavClick} className={navActive === "/" ? "active" : ""}>Home</Link></li>
        <li><Link to="/about-us" onClick={handleNavClick} className={navActive === "/about-us" ? "active" : ""}>About Us</Link></li>
        <li><Link to="/products" onClick={handleNavClick} className={navActive === "/products" ? "active" : ""}>Products</Link></li>
        <li><Link to="/contact-us" onClick={handleNavClick} className={navActive === "/contact-us" ? "active" : ""}>Contact Us</Link></li>
        {/* <li>
          <ul className="soci-icondivul">
            <li>
              <a href="/" target="_blank">
                <img src={LinkedInIcon} alt="LinkedIn" />
              </a>
            </li>

            <li>
              <a href="/" target="_blank">
                <img src={InstagramIcon} alt="Instagram" />
              </a>
            </li>

            <li>
              <a href="/" target="_blank">
                <img src={facebookIcon} alt="Facebook" />
              </a>
            </li>

          </ul>
        </li> */}
      </ul>
    </Box>
  );
};

export default Header;
